export const PLACEMENTS = {
  HOMEPAGE_HERO: { label: "Нүүр хуудас — Hero" },
  HOMEPAGE_SLIDER: { label: "Нүүр хуудас — Slider" },
  NEWS_LIST_HERO: { label: "Мэдээний жагсаалт — Hero" },
  CARD_LIST_HERO: { label: "Картын жагсаалт — Hero" },
  LOAN_LIST_HERO: { label: "Зээлийн жагсаалт — Hero" },
  INSURANCE_LIST_HERO: { label: "Даатгалын жагсаалт — Hero" },
  SAVING_LIST_HERO: { label: "Хадгаламжын жагсаалт — Hero" },
  APARTMENT_LIST_HERO: { label: "Орон сууцын жагсаалт — Hero" },
};

export const BANNER_STATUSES = {
  PUBLISHED: { label: "Нийтлэгдсэн", color: "success" },
  DRAFT: { label: "Ноорог", color: "default" },
};

// Derived
export const PLACEMENT_OPTIONS = Object.entries(PLACEMENTS).map(([key, v]) => ({
  value: key,
  label: v.label,
}));
export const PLACEMENT_LABEL = (p) => PLACEMENTS[p]?.label ?? p;

export const BANNER_STATUS_OPTIONS = Object.entries(BANNER_STATUSES).map(
  ([key, v]) => ({ value: key, label: v.label }),
);
export const BANNER_STATUS_LABEL = (s) => BANNER_STATUSES[s]?.label ?? s;
export const BANNER_STATUS_COLOR = (s) =>
  BANNER_STATUSES[s]?.color ?? "default";
